import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    link: {
      textDecoration: "underline",
      textAlign: "center",
      marginTop: 24,
      [theme.breakpoints.up("mobile")]: {
        marginTop: 0,
      },
    },
    text: {
      textAlign: "left",
    },
    renewalButton: {
      margin: [20, 0],
    },
    captionText: {
      marginTop: 60,
      "& a": {
        "&:hover": {
          "@media (hover: hover)": {
            textDecoration: "underline",
          },
        },
      },
    },
    button: {
      marginTop: 24,
      marginBottom: 24,
    },
    divider: {
      marginBottom: 10,
    },
    placeholder: {
      margin: [10, "auto"],
    },
  }),
  { name: "EditRenewal" },
);
